import { DataLayer } from '@grandvisionhq/analytics';

const pushImageGalleryItemExpandedEvent = (isExpanded)=>{
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'click',
        eventLabel: isExpanded ? 'show more' : 'show less'
    });
};

export { pushImageGalleryItemExpandedEvent };
//# sourceMappingURL=ImageGalleryEvents.js.map
